// extracted by mini-css-extract-plugin
export default {"button":"SportsTeamButton_button","name":"SportsTeamButton_name","image":"SportsTeamButton_image","visitor":"SportsTeamButton_visitor"};